import fetch from './index'
const crystalUrl = '/crystal'
const bariteUrl='/barite'

//获取用户信息
export function getUserInfo(data) {
  return fetch({
    url: crystalUrl+ '/api/app/user/info',
    method: 'get',
    params: data
  })
}
//获取客户信息
export function getAccountInfo(data) {
  return fetch({
    url: bariteUrl+ '/account/info',
    method: 'get',
    params: data
  })
}
//查询用户资金账户列表
export function cashAccounts(data) {
  return fetch({
    url: bariteUrl + '/account/cashAccounts',
    method: 'get',
    params: data
  })
}
// 帮助中心--所有分类
export function helpAllCategory(data) {
  return fetch({
    url: crystalUrl+ '/barite/articleManage/getAllArticleCategory',
    method: 'get',
    params: data
  })
}
// 帮助中心-- 文章列表
export function helpList(data) {
  return fetch({
    url: crystalUrl+ '/barite/articleManage/getArticleList',
    method: 'get',
    params: data
  })
}
// 帮助中心-- 文章详情
export function helpDetail(data) {
  return fetch({
    url: crystalUrl+ '/barite/articleManage/getArticleDetailById',
    method: 'get',
    params: data
  })
}
	//获取首页banner轮播图
  export function getPCRotationPictureList(data) {
    return fetch({
      url: crystalUrl+ '/barite/pc/getPCRotationPictureList',
      method: 'get',
      params: data
    })
  }
  // 获取Apollo配置
export function getApolloConfig(data) {
  return fetch({
    url:  '/security/app/config/list',
    method: 'get',
    params: data,
    noIntercept: true
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js